import React, { useContext } from "react";
import moment from "moment";
import 'moment/locale/th'
import { Modal, Button } from 'react-bootstrap';
import { AppContext } from "../context/ContextProvider";
import { useTranslation } from 'react-i18next'

const SelectDateConfirmModal = ({ show, onHide = () => { }, onConfirm = () => { }, start_date, end_date }) => {
  const { getBookingCartData } = useContext(AppContext);
  const bookingCartData = getBookingCartData();
  const { t } = useTranslation()

  return (
    <>
      <Modal size="md" show={show} onHide={onHide} backdrop="static">
        <Modal.Header closeButton>
          <Modal.Title>{t('confirm_date_selected')}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* ขีดเส้นใต้ */}
          <p className="mb-2 text-danger">{t('new_date_selected')} <span className="underline " style={{ fontWeight: 'bold', textDecoration: 'underline' }}>{t('not_match_previous_stay_date')}</span> {t('confirm_date_prompt')}</p>
          <div>
            <p className="mb-0 text-black">{t('previous_stay_date')} : {moment(bookingCartData?.start_date).format('DD/MM/YYYY')} - {moment(bookingCartData?.end_date).format('DD/MM/YYYY')}</p>
            <p className="text-black">{t('new_stay_date')} : {moment(start_date).format('DD/MM/YYYY')} - {moment(end_date).format('DD/MM/YYYY')}</p>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="warning" onClick={() => {
            onConfirm('cart');
            onHide();
          }}>{t('use_previous_stay_date')}</Button>
          <Button variant="primary" onClick={() => {
            onConfirm('selected');
            onHide();
          }}>{t('confirm_new_stay_date')}</Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default SelectDateConfirmModal;
